import bilAPI from "../api";

export const sendMailByRole = (body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/auth/accounts/send_mail_by_role/`, body, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
